import { ReactNode } from 'react';
import {
  SuggestionLayoutView,
  ButtonBarContainer,
  ListContainer,
} from './SuggestionsLayoutTemplate.styles';

interface Props {
  buttonBar: ReactNode;
  list: ReactNode;
}

export const SuggestionsLayoutTemplate = ({ buttonBar, list }: Props) => (
  <SuggestionLayoutView>
    <ButtonBarContainer>{buttonBar}</ButtonBarContainer>
    <ListContainer>{list}</ListContainer>
  </SuggestionLayoutView>
);
